import { useEffect, useState } from 'react';
import { StrikeThroughHeader } from '../../../../components/Headers/strikethrough-header/strikethrough-header';
import { Stack, Alert, Button, TextField } from '@mui/material';
import { Wizard, PhoneStepRenderer } from '../../../../components/Claimant';
import { useQuery } from '@tanstack/react-query';
import { getPolicyByPhone, GetTransactionSteps } from '../../../../api/requestclaimant';
import { useNavigate } from 'react-router-dom';
import LoadingIndicator from '../../../../components/Global/loading-indicator/loading-indicator';

const RequestClaimant = () => {
  const navigate = useNavigate();
  const [steps, setSteps] = useState([]);
  const [currentPolicy, setCurrentPolicy] = useState(undefined);
  const [referenceId, setReferenceId] = useState('');
  const TransactionID = { transactionID: 4 };
  const stepsQuery = useQuery({
    queryKey: ['GetTransactionSteps', TransactionID],
    queryFn: () => GetTransactionSteps({ TransactionID })(),
    enabled: false,
  });
  const policyQuery = useQuery({
    queryKey: ['getPolicyData'],
    queryFn: () => getPolicyByPhone({ FindPolicyNumber: referenceId })(),
    enabled: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
    networkMode: 'offlineFirst',
  });

  useEffect(() => {
    if (stepsQuery.isSuccess && stepsQuery.data) {
      setSteps(stepsQuery.data);
    }
  }, [stepsQuery.isSuccess, stepsQuery.data]);

  useEffect(() => {
    if (policyQuery.isSuccess && policyQuery.data) {
      if (policyQuery.data.policies && policyQuery.data.policies.length > 0)
        setCurrentPolicy(policyQuery.data.policies[0]);
      else setCurrentPolicy('No policy');
    }
  }, [policyQuery.isSuccess, policyQuery.data]);

  const handelBegin = () => {
    setSteps([]);
    setCurrentPolicy(undefined);
    policyQuery.refetch();
  };

  useEffect(() => {
    localStorage.removeItem('policyCheckItems');
  }, []);

  useEffect(() => {
    if (currentPolicy && currentPolicy.status === 'Active') {
      stepsQuery.refetch();
    }
  }, [currentPolicy]);

  return (
    <>
      <StrikeThroughHeader>Request Claimant</StrikeThroughHeader>
      <Stack sx={{ marginBottom: '10px' }} direction="row" gap={2}>
        <TextField
          size="small"
          required
          id="outlined-basic"
          label="Reference Id"
          variant="outlined"
          value={referenceId}
          onChange={(e) => setReferenceId(e.target.value)}
        />
        <Button
          disabled={referenceId === ''}
          variant="outlined"
          onClick={handelBegin}
          sx={{ px: '2rem' }}
          size="small"
        >
          Begin
        </Button>
      </Stack>
      {policyQuery.isSuccess && currentPolicy && currentPolicy.status === 'Terminated' && (
        <Alert severity="warning">Policy is terminated</Alert>
      )}
      {policyQuery.isSuccess && currentPolicy && currentPolicy.status === 'Pending' && (
        <Alert severity="info">Policy is pending</Alert>
      )}
      {policyQuery.isSuccess && currentPolicy === 'No policy' && (
        <Alert severity="info">Policy not found</Alert>
      )}
      {policyQuery && policyQuery.isFetching && <LoadingIndicator />}
      {steps && steps.length > 0 && (
        <Wizard
          steps={steps}
          referenceID={referenceId}
          renderer={PhoneStepRenderer}
          endTransactionHandler={() => navigate('/Software')}
          insuredFullName=""
        />
      )}
      {currentPolicy && policyQuery.isFetching && Object.keys(currentPolicy).length === 0 && (
        <Stack direction="column" justifyContent="center" alignItems="center" mt={10}>
          <Alert severity="warning">Please! Enter a valid reference id on input.</Alert>
        </Stack>
      )}
    </>
  );
};

export default RequestClaimant;
